{
    "Title": "ACD-Aktivitätselementdetails",
    "SectionTitleDatetimevalues": "DATUM\/ZEITWERTE",
    "SectionTitleDeviceandacdinfo": "GERÄTE- UND ACD-INFORMATIONEN",
    "SectionTitleStatusvalues": "STATUSWERTE",
    "SectionTitleAssociatedtelephonyenv": "ZUGEHÖRIGE TELEFONIEUMGEBUNG",
    "SectionTitleDiagnosticvalues": "DIAGNOSEWERTE",
    "ButtonHelp": "Hilfe",
    "ButtonClose": "Nah dran",
    "ColumnHeaderValue": "Wert",
    "ColumnHeaderFieldStatistic": "Feld \/ Statistik",
    "ButtonCollapseall": "Alle reduzieren",
    "NAME": "ACDDNDActivity"
}